import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { useColorScheme } from '@/theme';

import { MoonIcon, SunIcon } from './icons';

// IconButton that flips the color scheme between light and dark. Shows the icon of the
// mode the click would switch INTO (moon while in light mode, sun while in dark mode) —
// matches the convention most modern apps use.
export function ThemeToggleButton() {
  const { t } = useTranslation();
  const { mode, toggle } = useColorScheme();
  const isDark = mode === 'dark';
  const label = isDark ? t('toggleTheme.toLight') : t('toggleTheme.toDark');

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={toggle}
        aria-label={label}
        sx={{ width: 40, height: 40, color: 'text.primary' }}
      >
        {isDark ? <SunIcon /> : <MoonIcon />}
      </IconButton>
    </Tooltip>
  );
}
